import { useAuth } from '../hooks/use-auth';

import { LogoFull } from './logo';

/**
 * Shown when the signed-in user is NOT in OWNER_EMAILS — admin-api
 * returned 403 from `/owner/me`. The signed-in email is displayed so
 * the user can verify they used the right account; sign-out lets
 * them try a different one.
 */
export function Lockout() {
  const { user, signOut } = useAuth();
  return (
    <div className="nw-lockout">
      <LogoFull size={48} tagline="Admin" />
      <h1 className="nw-lockout__title">Not authorised</h1>
      <p className="nw-lockout__body">
        Signed in as <span className="nw-lockout__email">{user?.email}</span>,
        but this account is not in the owner allowlist. Ask infra to add
        your email to <code>OWNER_EMAILS</code> on the admin-api service.
      </p>
      <button
        type="button"
        onClick={() => void signOut()}
        className="nw-btn nw-btn--secondary"
      >
        Sign out
      </button>
    </div>
  );
}
